import axios from "axios";
import { getToken } from "../../auth/authService";

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchAllWebImages = async () => {
  try {
    console.log("[fetchAllWebImages] fetching...");
    const res = await axios.get(`${BASE}/admin/web-images`, { headers: authHeaders() });
    console.log("[fetchAllWebImages] count:", res.data?.length);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[fetchAllWebImages] error status:", err.response?.status);
    console.error("[fetchAllWebImages] error data:", err.response?.data);
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch images" };
  }
};

export const uploadWebImage = async (file, name, category) => {
  try {
    const form = new FormData();
    form.append("file", file);
    form.append("name", name);
    form.append("category", category);

    console.log("[uploadWebImage] file:", file?.name, "size:", file?.size, "type:", file?.type);
    console.log("[uploadWebImage] name:", name, "category:", category);
    console.log("[uploadWebImage] token present:", !!authHeaders().Authorization);

    const res = await axios.post(`${BASE}/admin/web-images/upload`, form, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    console.log("[uploadWebImage] response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[uploadWebImage] error status:", err.response?.status);
    console.error("[uploadWebImage] error data:", err.response?.data);
    console.error("[uploadWebImage] error headers:", err.response?.headers);
    console.error("[uploadWebImage] full error:", err);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Upload failed" };
  }
};

export const replaceWebImage = async (id, file) => {
  try {
    const form = new FormData();
    form.append("file", file);

    console.log("[replaceWebImage] id:", id, "file:", file?.name, "size:", file?.size);
    console.log("[replaceWebImage] token present:", !!authHeaders().Authorization);

    const res = await axios.put(`${BASE}/admin/web-images/${id}/replace`, form, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    console.log("[replaceWebImage] response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[replaceWebImage] error status:", err.response?.status);
    console.error("[replaceWebImage] error data:", err.response?.data);
    console.error("[replaceWebImage] full error:", err);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Replace failed" };
  }
};

export const deleteWebImage = async (id) => {
  try {
    console.log("[deleteWebImage] id:", id);
    console.log("[deleteWebImage] token present:", !!authHeaders().Authorization);
    const res = await axios.delete(`${BASE}/admin/web-images/${id}`, { headers: authHeaders() });
    console.log("[deleteWebImage] response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[deleteWebImage] error status:", err.response?.status);
    console.error("[deleteWebImage] error data:", err.response?.data);
    console.error("[deleteWebImage] full error:", err);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
